import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import {actions as system} from '../reducers/system';
import {actions as language} from '../reducers/language';
import { Formik, Form, Field } from 'formik';
import _ from 'lodash';

@connect(
	state => {
		return {
			selectedLanguage: state.language.selected
		}
	},
	dispatch => {
		return {
			clearMessages: () => dispatch(system.clearMessages()),
			createLanguage: (languageToCreate) => dispatch(language.create(languageToCreate)),
			updateLanguage: (languageToUpdate) => dispatch(language.update(languageToUpdate))
		};
	}
)
export default class LanguageForm extends Component
{

	constructor(props){
		super(props);

		this.state = {
			isUpdateMode: _.has(props.match.params, 'language')
		}
	}

	render() {
		const initialState = this.props.selectedLanguage || {
			identifier: '',
			name: ''
		};

		// when the form is to update wait with rendering until the language is loaded
		return this.state.isUpdateMode && this.props.selectedLanguage === null ? null : (
			<div className="card">
				<Formik
					initialValues={initialState}
					onSubmit={(language, actions) => {
						this.props.clearMessages();
						const promise = this.props.selectedLanguage ? this.props.updateLanguage(language) : this.props.createLanguage(language);
						promise.then(
							success => {
								if(success) {
									this.props.history.push('/languages');
								} else {
									actions.setSubmitting(false);
								}
							}
						);
					}}
					render={({ isSubmitting }) => (
						<Form>
							<div className="card-body">
								<div className="form-group has-label">
									<label>Identifier (ISO-Code) *</label>
									<Field type="text" className="form-control" name="identifier" />
								</div>
								<div className="form-group has-label">
									<label>Name *</label>
									<Field type="text" className="form-control" name="name"/>
								</div>
								<hr/>
							</div>
							<div className="card-footer text-right">
								<Link to="/languages" className="btn btn-secondary">Cancel</Link>
								<button type="submit" className="btn btn-primary" disabled={isSubmitting}>
									{this.state.isUpdateMode ? 'Update language' : 'Create language'}
								</button>
							</div>
						</Form>
					)}
				/>
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./React/src/screens/LanguageForm.js